import { assign } from 'lodash';
import EventEmitter from '@wsb/commerce-event-emitter';
import { AppDispatcher } from '@wsb/guac-widget-shared/lib/common/ols-core/shared-bundle';
import { ApplePayConstants } from '@wsb/guac-widget-shared/lib/common/ols-core/shop-bundle';

class ApplePayStore extends EventEmitter {
  constructor() {
    super(...arguments);

    this.state = {
      timeout: 1000,
      inSession: false,
      stripeWasLoaded: false,
      availabilityWasChecked: false,
      applePayIsAvailable: false,
      applePayIsSupported: false
    };
    this.register();
  }

  setState(newState) {
    assign(this.state, newState);
    this.emit('change');
  }

  getState() {
    return this.state;
  }

  register() {
    this.dispatchToken = AppDispatcher.register(payload => {
      const { action } = payload;
      const { data } = action;

      switch (action.type) {
        case ApplePayConstants.SESSION_STARTED:
          this.setState({
            inSession: true
          });
          break;
        case ApplePayConstants.SESSION_CANCELED:
        case ApplePayConstants.SESSION_FAILED:
          this.setState({
            inSession: false
          });
          break;
        case ApplePayConstants.STRIPE_WAS_LOADED:
          this.setState({
            stripeWasLoaded: true
          });
          break;
        case ApplePayConstants.AVAILABILITY_WAS_CHECKED:
          this.setState({
            availabilityWasChecked: true
          });
          break;
        case ApplePayConstants.APPLE_PAY_IS_AVAILABLE:
          this.setState({
            applePayIsAvailable: true
          });
          break;
        case ApplePayConstants.PAYMENT_REQUEST_IS_AVAILABLE:
          this.setState({
            applePayIsAvailable: true,
            applePayIsSupported: data.applePay
          });
          break;
        default:
          break;
      }
    });
  }
}

export default new ApplePayStore();
